function parseResponseData(data) {
  if((!data) || data.length==0){
      return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function serviceFactory({ api }) {
  const getAllMarqueData = ({channel,metaData}) =>
    api
    .getAllMarqueData(channel, metaData)
    .then(parseResponseData)
    .catch(() => null);

  const saveMarqueData = ({requestBody,metaData}) =>
    api
    .saveMarqueData(requestBody, metaData)
    .then(parseResponseData)
    .catch(() => null);

    return {
      getAllMarqueData,
      saveMarqueData
    }
}

module.exports = serviceFactory;